import { render, staticRenderFns } from "./PlayerPlay.vue?vue&type=template&id=040e2906"
import script from "./PlayerPlay.vue?vue&type=script&lang=js"
export * from "./PlayerPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports